/**=========================================================
 * Module: exchangerates.js
 * ExchangeRates Controller
 =========================================================*/

 App.controller("ExchangeratesController", ["$rootScope", "$scope", "$state", "$translate", "$window", "$localStorage", "$timeout", "toggleStateService", "Restangular", "DataService", '$http',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $http) 
 {
   "use strict";

   $scope.page = {
     title: 'labels.EXCHANGERATES',
     subTitle: ""
   };

   $scope.froms = []
   function load(){
     $scope.loading = true;
     D.query('exchangerate','latest=true').then(function(response){
        $scope.rates = response;
        $scope.loading = false;
        for(var i=0; i<$scope.rates.length; i++){
          if($scope.froms.indexOf($scope.rates[i].from)<0){
            $scope.froms.push($scope.rates[i].from)
          }
        }
        //$timeout(load, 30000);
      }).catch(console.error);
    }

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function () {

        if ($rootScope.user.id) {
            $scope.initialized = true;
            load();
          } else {
            if (!$scope.watchActivated) {
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function () {
                    if (!$scope.initialized) {
                        $scope.init();
                    }
                });
            }
        }
    }
    $scope.init();

   function yyyymmdd(d, s) {
    d.setDate(d.getDate()-s);
    var mm = d.getMonth() + 1; // getMonth() is zero-based
    var dd = d.getDate();
  
    return [d.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
           ].join('');
    }

   $scope.pastRates = {}
   $scope.togglePast = function(rate){
     if($scope.pastRates[rate.from+rate.to] && $scope.pastRates[rate.from+rate.to].length){
      $scope.pastRates[rate.from+rate.to] = []
     } else {
       $scope.loadPast(rate)
     }
   }
   $scope.loadPast = function(rate) {
    D.query('exchangerate','from='+rate.from+'&to='+rate.to+'&_range=20').then(function(response){
      response.sort(function(a, b) { return a.T<b.T ? 1 : -1}).shift()
      $scope.pastRates[rate.from+rate.to] = response
    }).catch(console.error);
   }
}
]);
